




















import Vue from "vue";
import RoomPerformance from "@/components/dashboard/rooms/room/RoomPerformance.vue";
import RoomInformation from "@/components/organisms/rooms/RoomInformation.vue";
import { RoomDetail } from "@/models/room";
import PerformanceLive from "@/components/dashboard/performance/Performance.vue";
import RoomInformationAndroid from "@/components/organisms/rooms/RoomInformationAndroid.vue";
import RoomInformationIos from "@/components/organisms/rooms/RoomInformationIos.vue";
import RemoteManagementAndroid from "@/components/organisms/rooms/RemoteManagementAndroid.vue";
import RemoteManagementIos from "@/components/organisms/rooms/RemoteManagementIos.vue";
import RoomDisplaysAndroid from "@/components/dashboard/rooms/room/RoomDisplaysAndroid.vue";
import RoomActions from "@/components/dashboard/rooms/room/RoomActions.vue";

export default Vue.extend({
  name: "RoomDetailInfo",
  components: {
    PerformanceLive,
    RoomPerformance,
    RoomInformation,
    RoomInformationAndroid,
    RoomInformationIos,
    RemoteManagementAndroid,
    RemoteManagementIos,
    RoomDisplaysAndroid,
    RoomActions,
  },
  props: {
    roomId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      // error: "",
      // updateRequiredDialog: false
    };
  },
  computed: {
    room(): RoomDetail {
      return this.$store.getters["room/room"];
    },
    isAndroid(): boolean {
      return this.room?.deviceType === "AndroidReceiver";
    },
    isIos(): boolean {
      return this.room?.deviceType === "iOS";
    },
  },
});
